import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "deliveries" };
const _hoisted_2 = {
    key: 0,
    class: "data-table__value-topic"
};
const _hoisted_3 = { class: "data-table__value-text" };
const _hoisted_4 = {
    key: 0,
    class: "data-table__value",
    style: { height: '100%' }
};
const _hoisted_5 = ["src", "alt"];
import { onMounted, ref } from 'vue';
import DataTable from "@astina/paloma-common-ui/src/components/DataTable.vue";
import deliveryRepository from '../services/DeliveryRepository';
import events from "@astina/paloma-common-ui/src/services/EventBus";
import Spinner from "@astina/paloma-common-ui/src/components/Spinner.vue";
import { useRoute, useRouter } from "vue-router";
export default /*@__PURE__*/ _defineComponent({
    __name: 'DeliveriesView',
    setup(__props) {
        const route = useRoute();
        const router = useRouter();
        const searchRequest = ref({
            query: null,
            filters: []
        });
        const enforceSearchRequest = ref(false);
        const grid = ref(null);
        const source = deliveryRepository.getGridItemsSource();
        onMounted(() => {
            const orderNumber = route.query.order;
            if (orderNumber) {
                searchRequest.value.filters = [{
                        attribute: "orders.orderNumber",
                        values: [orderNumber],
                    }];
                enforceSearchRequest.value = true;
            }
            deliveryRepository.getGridConfig().then(g => {
                grid.value = g;
            });
        });
        function activateItem(item) {
            if (!item) {
                closeDetailView();
            }
            else {
                router.push({
                    name: 'deliveries_delivery',
                    params: { id: item.id }
                }).catch(() => {
                });
            }
        }
        function deliveryStatusBadge(item) {
            const status = item.attributes['status'];
            switch (status) {
                case 'pending':
                case 'ready':
                    return 'text-bg-secondary';
                case 'delivered':
                    return 'text-bg-success';
                default:
                    return 'text-bg-info';
            }
        }
        function closeDetailView() {
            router.push({ name: 'deliveries' });
        }
        function selectNextItem() {
            events.$emit('deliveries.nav-next');
        }
        function selectPrevItem() {
            events.$emit('deliveries.nav-prev');
        }
        return (_ctx, _cache) => {
            const _component_router_link = _resolveComponent("router-link");
            const _component_router_view = _resolveComponent("router-view");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(Spinner, {
                    loading: !grid.value
                }, null, 8, ["loading"]),
                _cache[7] || (_cache[7] = _createTextVNode()),
                (grid.value)
                    ? (_openBlock(), _createBlock(DataTable, {
                        key: 0,
                        name: "deliveries",
                        title: _ctx.$t('deliveries'),
                        "search-request": searchRequest.value,
                        "enforce-search-request": enforceSearchRequest.value,
                        grid: grid.value,
                        source: _unref(source),
                        onActivateItem: activateItem
                    }, {
                        "list-item": _withCtx((props) => [
                            _createVNode(_component_router_link, {
                                to: { name: 'deliveries_delivery', params: { id: props.item.id } },
                                class: "data-table__value"
                            }, {
                                default: _withCtx(() => [
                                    (props.item.topic)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.$dateTime(props.item.topic)), 1))
                                        : _createCommentVNode("", true),
                                    _cache[3] || (_cache[3] = _createTextVNode()),
                                    _createElementVNode("span", _hoisted_3, _toDisplayString(props.item.title), 1)
                                ]),
                                _: 2
                            }, 1032, ["to"])
                        ]),
                        "cell-_items": _withCtx((props) => [
                            (props.item.attributes['_items'])
                                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.item.attributes['_items'].items, (item, index) => {
                                        return (_openBlock(), _createElementBlock("img", {
                                            src: item.imageUrl,
                                            key: index,
                                            alt: item.name,
                                            style: { 'margin-right': '.2rem' }
                                        }, null, 8, _hoisted_5));
                                    }), 128))
                                ]))
                                : _createCommentVNode("", true)
                        ]),
                        "cell-status": _withCtx((props) => [
                            _createElementVNode("span", {
                                class: _normalizeClass(["badge", deliveryStatusBadge(props.item)])
                            }, _toDisplayString(_ctx.$t('delivery.status.' + props.item.attributes['status'])), 3)
                        ]),
                        "cell-deliveryMethod": _withCtx((props) => [
                            _createTextVNode(_toDisplayString(_ctx.$te('shipping_method.' + props.item.attributes['deliveryMethod'])
                                ? _ctx.$t('shipping_method.' + props.item.attributes['deliveryMethod'])
                                : props.item.attributes['deliveryMethod']), 1)
                        ]),
                        _: 1
                    }, 8, ["title", "search-request", "enforce-search-request", "grid", "source"]))
                    : _createCommentVNode("", true),
                _cache[8] || (_cache[8] = _createTextVNode()),
                _createVNode(_component_router_view, {
                    onClose: _cache[0] || (_cache[0] = ($event) => (closeDetailView())),
                    onNext: _cache[1] || (_cache[1] = ($event) => (selectNextItem())),
                    onPrev: _cache[2] || (_cache[2] = ($event) => (selectPrevItem()))
                })
            ]));
        };
    }
});
